import classNames from 'classnames';

import { useCheckGameBannerAvailable } from 'src/hooks/useCheckGameBannerAvailable';
import { PromoGameBanner } from 'src/modules/Promo/Banners/PromoGameBanner';
import { useLocation } from 'react-router';
import { useMemo } from 'react';
import { useWindowSize } from 'src/modules/store/windowSizeStore';
import { CookiesBanner } from 'src/router/components/CookiesBanner';
import { Portal } from 'src/router/components/Portal/Portal';

export const GptGamesBanners = () => {
  // проверка роута для промо баннера catch-game
  const isShowGameBanner = useCheckGameBannerAvailable();
  const { isDesktopLayout } = useWindowSize();
  const { pathname } = useLocation();

  const stickToBottom = useMemo(() => {
    const pagesWithoutNavbar = ['game/', 'welcome-bonus', 'account'];
    return isDesktopLayout || pagesWithoutNavbar.some((route) => pathname.includes(route));
  }, [pathname, isDesktopLayout]);

  return (
    <Portal targetElementId="root">
      <div
        className={classNames(
          'fixed left-0 z-[500] w-full flex flex-col gap-5 pointer-events-auto',
          stickToBottom ? 'bottom-0' : 'bottom-[85px]'
        )}>
        {isShowGameBanner && <PromoGameBanner />}
        <CookiesBanner />
      </div>
    </Portal>
  );
};
